import axios, { type AxiosPromise, type AxiosStatic } from 'axios'
import { UAParser } from 'ua-parser-js'
import { merge } from 'lodash-es'
import type { KpiData } from '@/types/KpiData'
import { KpiOperation } from '@/types/enums/KpiOperation'

export default class Kpi {
  headers: Record<string, string> = {}

  axios: AxiosStatic

  source: 'authui' | 'authsdk'

  basicData: KpiData = {}

  queue: AxiosPromise[] = []

  constructor(axios: AxiosStatic, source: 'authui' | 'authsdk') {
    this.source = source
    this.axios = axios
  }

  getAppInstance = () => {
    try {
      const parser = new UAParser()

      return {
        deviceBrand: `${parser.getDevice().vendor} ${parser.getDevice().model}`,
        agentVersion: parser.getBrowser().version,
        agentName: parser.getBrowser().name,
        userAgent: navigator.userAgent
      }
    } catch (_) {
      return {
        userAgent: navigator.userAgent
      }
    }
  }

  setHeaders = (headers: {
    srcCorrelationId: string
    srcClientId: string
    serviceId: string
    traceId: string
  }) => {
    this.headers = {
      'content-type': 'application/json',
      'x-src-trace-id': headers.traceId,
      'correlation-id': headers.srcCorrelationId,
      'program-id': headers.serviceId
    }
  }

  flush = async () => {
    try {
      await Promise.all(this.queue)
    } catch (_) {
      // Do nothing
    }
  }

  track = async (
    data: KpiData,
    state: 'COMPLETED' | 'FAILED' | 'STARTED',
    operation: KpiOperation,
    resource = 'CARD'
  ) => {
    this.queue.push(
      axios({
        method: 'POST',
        url: '/api/event/publish',
        data: {
          data: {
            ...merge(data, this.basicData),
            appInstanceData: this.getAppInstance()
          },
          state,
          operation,
          namespace: `src.kpi.${this.source}`,
          source: JSON.stringify({
            domain: `MA_${this.source}`,
            version: '1.0', // TODO: get this from package.json or .env
            environment: 'stage'
          }),
          resource,
          tags: ['kpi']
        },
        headers: this.headers
      })
    )
  }
}
